import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileCancelButton from "../button/mobileCancelButton";
import LastBookingAccess from "../../../services/database/lastBookingAccess"
import {
    getDataFromAbsenceTable,
    getDataFromCostUnitTable,
    getDataFromMachineTable,
    getDataFromOrderItemTable,
    getDataFromOrderTable,
    getDataFromPersonTable,
    getDataFromProjectTable,
    getDataFromWorkCombinationTable,
    getDataFromWorkplaceTable,
    getDataFromWorkprocessTable
} from "../../../utils/mobileUtils";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

// import { toast } from "react-toastify";

class MobileRecordingFromTable extends MobileRecording {
    constructor(props) {
        super();
    }

    state = {
        list: {entries: []},
        searchText: ""
    };

    continueIfOnlyOneItem = false;
    // myInterval = null;

    componentDidMount = async () => {
        const {currentRecordingFlowChart, database, recordData} = this.props;

        let list = [];

        let lastBooking = null;
        if (recordData && recordData.fields) {
            lastBooking = await LastBookingAccess.getByPersonAndTable(database, recordData.fields["personDbId"], recordData.table)
        }

        switch (currentRecordingFlowChart.table) {
            case "person":
                list = await getDataFromPersonTable(database);
                break;
            case "absence":
                list = await getDataFromAbsenceTable(database);
                break;
            case "project":
                list = await getDataFromProjectTable(database);
                break;
            case "order":
                list = await getDataFromOrderTable(database);
                break;
            case "orderItem":
                const orderDbId = this.props.recordData.fields["orderDbId"];
                list = await getDataFromOrderItemTable(database, orderDbId);
                break;
            case "costUnit":
                list = await getDataFromCostUnitTable(database);
                break;
            case "machine":
                list = await getDataFromMachineTable(database);
                break;
            case "workplace":
                list = await getDataFromWorkplaceTable(database);
                break;
            case "workprocess":
                list = await getDataFromWorkprocessTable(database);
                break;
            case "workCombination":
                list = await getDataFromWorkCombinationTable(database);
                break;
            default:
        }
        // if (currentRecordingFlowChart.continueIfOnlyOneItem === true && list.entries.length === 1) {
        //
        //     // console.log("MobileRecordingFromTable.componentDidMount(): 1 ---> automatisch weitermachen", list.entries[0]);
        //     this.setTableFields(
        //         list.entries[0]["dbId"],
        //         list.entries[0]["number"],
        //         list.entries[0]["surname"]
        //     );
        //     this.continueIfOnlyOneItem = true;
        //
        //     // this.myInterval = setInterval(() => {
        //     //     console.log("intervall");
        //     //     clearInterval(this.myInterval);
        //     //     this.onFieldContinue();
        //     // }, 1000);
        //
        //     this.onFieldContinue();
        //     return;
        //
        // }

        switch (currentRecordingFlowChart.table) {
            // case "person":
            //     break;
            // case "absence":
            //     break;
            case "project":
                if (lastBooking && lastBooking.projectDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.projectDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "order":
                if (lastBooking && lastBooking.orderDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.orderDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "orderItem":
                if (lastBooking && lastBooking.orderItemDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.orderItemDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "costUnit":
                if (lastBooking && lastBooking.costUnitDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.costUnitDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "machine":
                if (lastBooking && lastBooking.machineDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.machineDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "workplace":
                if (lastBooking && lastBooking.workplaceDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.workplaceDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            case "workprocess":
                if (lastBooking && lastBooking.workprocessDbId) {
                    let lastBookingItem = list.entries.find(it => {
                        return (it.dbId === lastBooking.workprocessDbId)
                    });
                    if (lastBookingItem) {
                        lastBookingItem = {...lastBookingItem};
                        lastBookingItem["lastBooking"] = true;
                        list.entries.unshift(lastBookingItem);
                    }
                }
                break;
            default:
        }

        this.setState({list});
    };

    setTableFields = (dbId, paramValue, paramDisplayValue) => {

        const {currentRecordingFlowChart, setRecordDataFieldAndDbId} = this.props;
        const {valueField, displayValueField} = this;

        if (valueField === null) return;

        let value = "";
        let displayValue = "";

        value = paramValue;
        if (displayValueField === null)
            displayValue = paramValue;
        else
            displayValue =
                paramDisplayValue;

        setRecordDataFieldAndDbId(
            `${currentRecordingFlowChart.table}DbId`,
            dbId,
            currentRecordingFlowChart.tableField,
            value,
            displayValue
        );

    }

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                const {currentRecordingFlowChart} = this.props;
                const {valueField, displayValueField} = this;

                if (valueField === null) return;

                this.setTableFields(
                    rowInfo.original["dbId"],
                    rowInfo.original[currentRecordingFlowChart.valueField],
                    rowInfo.original[currentRecordingFlowChart.displayValueField]
                )

                this.onFieldContinue();
            }
        };
    };

    // closeToast = () => {
    //   this.onFieldContinue();
    // };

    handleChange = ({currentTarget: input}) => {
        const searchText = input.value;
        this.setState({searchText});
    };

    render = () => {

        const {currentFlowChart, currentRecordingFlowChart} = this.props;
        const {list, searchText} = this.state;
        const {continueIfOnlyOneItem} = this;

        if (continueIfOnlyOneItem === true) {
            return (<React.Fragment></React.Fragment>);
        }

        let data = [];
        let columns = [
            {
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={currentRecordingFlowChart.title.text}
                        searchable={currentRecordingFlowChart.searchable}
                        searchHandler={this.handleChange}
                        value={searchText}
                    />
                ),
                columns: []
            }
        ];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        let fieldCounter = 0;
        let fields = [];
        for (const listedFieldItem of currentRecordingFlowChart.listedFields) {
            let column = {
                Header: listedFieldItem.title.text,
                accessor: listedFieldItem.fieldName
                // Cell: ({ original }) => (
                //   <div ref={this.inputRef} onClick={() => console.log("clicked")}>
                //     hello
                //   </div>
                // )
            };
            if (fieldCounter++ === 0) {
                column["Footer"] = () => (
                    <div className="text-left">
                        <MobileCancelButton
                            onClick={() => {
                                this.onFieldCancel();
                            }}
                            title={{text: "Abbr."}}
                        />
                    </div>
                );
            }
            columns[0].columns.push(column);
            fields.push(listedFieldItem.fieldName);
        }
        for (const hiddenFieldItem of currentRecordingFlowChart.hiddenFields) {
            let column = {accessor: hiddenFieldItem.fieldName, show: false};
            columns[0].columns.push(column);
            fields.push(hiddenFieldItem.fieldName);
        }

        for (const entryItem of list.entries) {
            let addItem = false;

            if (searchText && searchText.length > 0) {
                for (const fieldItem of fields) {
                    if (
                        typeof entryItem[fieldItem] === "string" &&
                        entryItem[fieldItem]
                            .toLowerCase()
                            .indexOf(searchText.toLowerCase()) >= 0
                    ) {
                        addItem = true;
                        break;
                    }
                }
            } else {
                addItem = true;
            }

            if (addItem) {
                let listItem = {};
                for (const fieldItem of fields) {
                    listItem[fieldItem] = entryItem[fieldItem];
                }
                if (entryItem["lastBooking"] === true)
                    listItem["lastBooking"] = true;
                data.push(listItem);
            }
        }

        // if (data.length === 1) {
        //   toast.info("...", {
        //     autoClose: 10,
        //     position: "bottom-right",
        //     onClose: () => this.closeToast()
        //   });
        // }

        // if (data.length <= 1) {
        //   this.onFieldContinue();
        //   return <React.Fragment></React.Fragment>;
        // }

        const tdStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    background: rowInfo.row._original.lastBooking === true ? "lightgrey" : ""
                }
            }
        };
        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    getTrProps={this.onRowClick}
                    getTdProps={tdStyle}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    };
}

export default MobileRecordingFromTable;
